module.exports = __webpack_public_path__ + "static/media/bg1.8ee621a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/bg1.png
// module id = 420
// module chunks = 0